import NeptuneElement from "../../NeptuneElement.js";

class Accordion extends NeptuneElement {
    templateMarkup = `
        <details>
            <summary>
                <slot name="title"></slot>
                <i class="fa-solid fa-caret-down"></i>
            </summary>
            <div>
                <slot name="body"></slot>
            </div>
        </details>
    `;

    componentCssUrl = '/src/components/core/accordion/accordion.css';

    constructor() {
        super();
        this.onToggle = this.onToggle.bind(this);
    }

    onToggle(){
        this.updateIcon();
        const detailsElement = this.shadowRoot.querySelector('details');
        if (detailsElement && detailsElement.open) {
            this.setAttribute('expanded', '');
        } else {
            this.removeAttribute('expanded');
        }
    };

    async connectedCallback() {
        await super.connectedCallback();
        this.processInitialAttributesAfterRender(Accordion.observedAttributes);
        this.setEventListeners();
        this.updateIcon();
    }

    async disconnectedCallback() {
        this.removeEventListeners();
        await super.disconnectedCallback();
    }

    static get observedAttributes() {
        return ['expanded', 'name'];
    }

    attributeChangedCallback(name, oldValue, newValue) {
        if (!this.isRendered) return;
        this.processAttribute(name, oldValue, newValue);
    }

    processAttribute(name, oldValue, newValue) {
        const detailsElement = this.shadowRoot.querySelector('details');
        if (!detailsElement) return;

        if (name === 'expanded') {
            const isExpanded = this.hasAttribute('expanded');
            if (isExpanded) {
                detailsElement.open = true;
            } else {
                detailsElement.open = false;
            }
            this.updateIcon();
        }

        if (name === 'name') {
            if (newValue) {
                detailsElement.setAttribute('name', newValue);
            } else {
                detailsElement.removeAttribute('name');
            }
        }
    }

    setEventListeners() {
        const detailsElement = this.shadowRoot.querySelector('details');
        if (detailsElement) {
            detailsElement.addEventListener('toggle', this.onToggle);
        }
    }

    removeEventListeners() {
        const detailsElement = this.shadowRoot.querySelector('details');
        if (detailsElement) {
            detailsElement.removeEventListener('toggle', this.onToggle);
        }
    }

    updateIcon() {
        const detailsElement = this.shadowRoot.querySelector('details');
        const iconElement = this.shadowRoot.querySelector('.fa-solid');
        if (!detailsElement || !iconElement) return;
        if (detailsElement.open) {
            iconElement.classList.remove('fa-caret-down');
            iconElement.classList.add('fa-caret-up');
        } else {
            iconElement.classList.remove('fa-caret-up');
            iconElement.classList.add('fa-caret-down');
        }
    }
}

customElements.define('neptune-accordion', Accordion);
export default Accordion;